// extracted by mini-css-extract-plugin
export default {"hasSearch":"Search_hasSearch__QYesd","SearchBox":"Search_SearchBox__3uAZX","formControlSearchIcon":"Search_formControlSearchIcon__xXGQY"};